// material-ui
import {} from '@mui/material'
import React from 'react'

import TitleService from 'title-service'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import AddProfileContainer from 'components/AddProfileContainer'
import AddProfileFormContainer from 'components/AddProfileFormContainer'
import AddProfileTitle from 'components/AddProfileTitle'
import ProfileHeader from 'components/ProfileHeader'
import { getUserClaims } from 'features/application/application-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

export default function SimpleList() {
  // Generate Grid
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  const [contextId, setContextId] = React.useState(null)
  const [saveArgs, setSaveArgs] = React.useState(null)

  useEffect(() => {
    if (
      claims?.user &&
      saveArgs?.profileName &&
      saveArgs?.isChild !== undefined &&
      saveArgs?.profileImage
    ) {
      dispatch(
        autoThunks.add_profile({
          args: (() => {
            function getSaveArgs(): any {
              return saveArgs
            }
            return getSaveArgs()
          })(),
          userId: claims?.fire_user,
          callback: (success: boolean, res: any) => {
            if (success) {
              profileAdded(success, res)
            } else {
              profileNotAdded()
            }
          },
        }),
      )
    }
  }, [
    claims?.user,
    saveArgs?.profileName,
    saveArgs?.isChild,
    saveArgs?.profileImage,
  ])

  function profileAdded(): any {
    history.back()
  }

  function profileNotAdded(): any {
    console.log('profile not added')
  }

  function main(subcomponent: any): any {
    return (() => {
      // great
      return (
        <>
          <div className="profile">
            <ProfileHeader
              onBtnClick={() => {
                history.back()
              }}
              btnTitle={TitleService('Cancel')}
            ></ProfileHeader>
            <AddProfileContainer>
              <AddProfileTitle></AddProfileTitle>
              <AddProfileFormContainer
                contextId={contextId}
                onSave={(args: {
                  name: string
                  isChild: boolean
                  profileImage: string
                }) => {
                  setSaveArgs(args)
                }}
              ></AddProfileFormContainer>
            </AddProfileContainer>
          </div>
        </>
      )
    })()
  }

  let output_main = main(null)

  return output_main
}
